import React from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { showDate } from '../../constant';

const ViewExpenses = () => {
  let location = useLocation();
  let navigate = useNavigate();
  let data = location.state
  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className="xl:flex xl:items-center xl:justify-between">
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Expense Details
            </h1>
            <button type="button" className="btn btn-white" onClick={()=>navigate('/dashboard/expense/')}>
              Back
            </button>
          </div>

          <div className="mt-8 md:mt-6 sm:flex sm:items-center sm:space-x-6">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                    <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  </svg>
                  <span className="text-gray-600">
                    Student Id
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Created - <span>{showDate(data.created_at)}</span>
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Updated - <span>{showDate(data.updated_at)}</span>
                  </span>
                </div>

                <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                    <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                    <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  </svg>
                  <span className="text-gray-600">
                    Deleted - <span>{showDate(data.deleted_at)}</span>
                  </span>
                </div>
              </div>
              <div className="mt-2 space-y-6">
                <div className="overflow-hidden bg-white rounded-lg shadow">
                  <div className="px-4 py-5 sm:p-6">
                    <div className="grid xl:grid-cols-6 gap-y-10">
                      <div className="xl:col-span-6 xl:pr-8 order-1 lg:order-1 md:order-2 sm:order-2 xs:order-2">
                        <div className="space-y-6">
                          <div>
                            <div className="flex items-center">
                              <p className="font-medium">
                                Expenses
                              </p>
                            </div>
      
                            <div className="mt-3 space-y-3">
                                <div className="bg-white border border-gray-100 rounded-lg shadow-md">
                                  <div className="px-4 py-5 sm:p-6">
                                    <table className="custom-table mt-2">
                                    <thead className=''>
                                      <tr>
                                        <th scope="col">
                                          Payee's Name
                                        </th>
                                        <th scope="col" className="hidden xl:table-cell">
                                          Payer's Name
                                        </th>
                                        <th scope="col" className="hidden sm:table-cell">
                                          Total Amount
                                        </th>
                                        <th scope="col" className="hidden lg:table-cell">
                                          Payment Type
                                        </th>
                                        <th scope="col" className="">
                                          Payment Date
                                        </th>
                                        <th scope="col" className="">
                                          Payment Status
                                        </th>
                                      </tr>
                                    </thead>
      
                                    <tbody id="elements-container">
                                      <tr className="draggable-element">
                                        <td className="font-medium">
                                          <div title="" className="hover:text-primary-600">
                                            {data.pay_to}
                                          </div>
                                        </td>
                                        <td className="hidden xl:table-cell whitespace-nowrap">
                                          {data.pay_from}
                                        </td>
                                        <td className="hidden sm:table-cell whitespace-nowrap">
                                          {data.amount}/-
                                        </td>
                                        <td className="hidden lg:table-cell whitespace-nowrap">
                                          {data.paymentIn.type}
                                        </td>
                                        <td>
                                          {showDate(data.Payment_date)}
                                        </td>
                                        <td>
                                        {
                                          data.is_active? 
                                          (<span className='px-4 py-2 bg-green-500 rounded-md text-white text-center'>Active</span>) 
                                          : 
                                          (<span className='px-4 py-2 bg-red-500 rounded-md text-white text-center'>Deactive</span>)
                                        }
                                        </td>
                                      </tr>
                                    </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div> 
    </div>
  )
}

export default ViewExpenses
